import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="w-full bg-[#1a1a1a] text-white py-10 mt-auto text-sm">
      <div className="w-full max-w-none px-2 sm:px-4 md:px-12 xl:px-32 mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          <div>
            <div className="font-bold text-lg mb-2">INDER EVENTS</div>
            <div className="mb-4">Your premier event planning and management partner for memorable celebrations.</div>
            <div className="flex gap-2 mt-2">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-primary">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-primary">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="hover:text-primary">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="hover:text-primary">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
          <div>
            <div className="font-bold mb-2">Quick Links</div>
            <div className="flex flex-col gap-1">
              <Link to="/" className="hover:text-primary">Home</Link>
              <Link to="/events" className="hover:text-primary">Events</Link>
              <Link to="/gallery" className="hover:text-primary">Gallery</Link>
              <Link to="/about" className="hover:text-primary">About Us</Link>
              <Link to="/contact" className="hover:text-primary">Contact Us</Link>
            </div>
          </div>
          <div>
            <div className="font-bold mb-2">Contact Info</div>
            <div className="mb-1">MAMA JI CHOWK, Purani Mandi, Dharampura</div>
            <div className="mb-1">Chheharta, Amritsar, Punjab 143105</div>
            <div className="mb-1">Phone: (+91) 98886-38873</div>
            <div className="mb-1">Email: indereventsproduction@gmail.com</div>
          </div>
        </div>
        <div className="mt-8 text-center text-xs text-gray-400">
          &copy; {new Date().getFullYear()} <Link to="/" className="hover:text-primary">Inder Events</Link>. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
